module.exports = __webpack_public_path__ + "static/media/luan_do.e60e1d05.png";